import { render, staticRenderFns } from "./createTemplateModal.vue.html?vue&type=template&id=25d913fa"
import script from "./createTemplateModal.controller?vue&type=script&lang=js&external"
export * from "./createTemplateModal.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports